import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { DeleteProductPositionsOverlay } from "./DeleteProductPositionsOverlay"
import { useDeleteProductPositionsOverlayModel } from "./hooks/useDeleteProductPositionsOverlayModel"

export interface DeleteProductPositionsOverlayPayload {
  projectID: string
  productPositions: ProductPosition[]
}

export interface DeleteProductPositionsOverlayConnectorProps {
  payload: DeleteProductPositionsOverlayPayload
}

export const DeleteProductPositionsOverlayConnector = React.memo(
  (props: DeleteProductPositionsOverlayConnectorProps) => (
    <DeleteProductPositionsOverlay
      {...useDeleteProductPositionsOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_PRODUCT_POSITIONS_OVERLAY: DeleteProductPositionsOverlayPayload
  }
}
